import { render, staticRenderFns } from "./formDialog.vue?vue&type=template&id=b6d2d2ac&scoped=true"
import script from "./formDialog.vue?vue&type=script&lang=js"
export * from "./formDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d2d2ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6d2d2ac')) {
      api.createRecord('b6d2d2ac', component.options)
    } else {
      api.reload('b6d2d2ac', component.options)
    }
    module.hot.accept("./formDialog.vue?vue&type=template&id=b6d2d2ac&scoped=true", function () {
      api.rerender('b6d2d2ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/audit/components/formDialog.vue"
export default component.exports